import { Link } from 'react-router-dom';
import './PortfolioMold.css';

export default function PortfolioElevator() {
  return (
    <main id="top">

      <section className="cs-hero">
        <div className="cs-bg"><img className="ph" src="/images/logistics-depot.jpg" alt="Project photo — USCG Base New Orleans" /></div>
        <div className="cs-scrim"></div>
        <div className="wrap-wide">
          <nav className="crumb"><Link to="/">Home</Link><span className="sep">/</span><Link to="/portfolio/">Portfolio</Link><span className="sep">/</span><b>Elevator Maintenance Contract</b></nav>
          <div className="cs-htext">
            <span className="eyebrow">Case study · U.S. Coast Guard</span>
            <h1>Government Elevator Maintenance Contract</h1>
            <div className="cs-facts">
              <div className="cs-fact"><div className="k">Client</div><div className="v">U.S. Coast Guard (DHS)</div></div>
              <div className="cs-fact"><div className="k">Contract Value</div><div className="v">$3,600</div></div>
              <div className="cs-fact"><div className="k">Status</div><div className="v">Awarded · Ongoing</div></div>
              <div className="cs-fact"><div className="k">Scope</div><div className="v">Proposal & Compliance</div></div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec-pad">
        <div className="wrap-wide">
          <div className="cs-layout" style={{ marginTop: '0' }}>

            <div className="cs-main">
              <div className="cs-block">
                <span className="cs-kicker">Project overview</span>
                <h2>Proposal support, compliance, and technical alignment, end to end.</h2>
                <p>This project involved helping our client win an Elevator Maintenance Government Contract for the US Coast Guard Base in New Orleans. Our role focused on proposal support, compliance review, and technical alignment with federal requirements. We assisted with scope review, pricing structure, and NAICS validation to ensure the submission met DHS and USCG standards.</p>
                <p>Our team also supported document accuracy and risk checks before submission. As a result of this structured approach, our client successfully secured the government contract. The elevator inspection, maintenance, and repair work is being performed by the awarded service provider.</p>
              </div>

              <div className="cs-block">
                <span className="cs-kicker">Key strategies</span>
                <h2 style={{ marginBottom: '22px' }}>How we positioned the win.</h2>
                <ul className="cs-strats">
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Reviewed solicitation and contract scope.</span></li>
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Verified NAICS and SAM compliance.</span></li>
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Supported pricing and cost structure.</span></li>
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Ensured technical work alignment.</span></li>
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Checked proposal accuracy before submission.</span></li>
                  <li><svg className="ico"><use href="#i-check" /></svg><span>Reduced compliance and submission risks.</span></li>
                </ul>
              </div>
            </div>

            <aside>
              <div className="cs-info">
                <div className="hd">Project Information</div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-landmark" /></svg></span><div><div className="k">Client</div><div className="val">Dept. of Homeland Security<br /><span className="mut">United States Coast Guard</span></div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-tag" /></svg></span><div><div className="k">Project Title</div><div className="val">USCG Base New Orleans Elevator Maintenance</div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-dollar" /></svg></span><div><div className="k">Contract Value</div><div className="val">$3,600.00 <span className="mut">USD</span></div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-hash" /></svg></span><div><div className="k">Contract Number</div><div className="val"><a href="#">70Z02925PNEWO0005</a></div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-hash" /></svg></span><div><div className="k">NAICS Code</div><div className="val">561210</div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-cal" /></svg></span><div><div className="k">Period of Performance</div><div className="val">January 2025 – Ongoing</div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-user" /></svg></span><div><div className="k">Point of Contact</div><div className="val">Carlton Ackiss, CWO<br /><span className="mut">carlton.m.ackiss@uscg.mil</span></div></div></div>
                <div className="cs-row"><span className="ic"><svg className="ico"><use href="#i-mappin" /></svg></span><div><div className="k">Location</div><div className="val">USCG Base New Orleans<br /><span className="mut">1790 Saturn Blvd., New Orleans, LA 70129</span></div></div></div>
              </div>
            </aside>

          </div>

          <div className="cs-cta">
            <div className="ct">
              <h3>Need our help to win government contracts?</h3>
              <p>Most people think federal contracting is simple — fill out a few forms and you're done. The reality is far more complex. Let our specialists handle it.</p>
            </div>
            <Link className="btn btn-light" to="/#contact">Contact Us <span className="arw">→</span></Link>
          </div>
        </div>
      </section>

      <section className="finalcta" id="contact">
        <div className="wrap">
          <span className="starrow center" style={{ marginBottom: '24px' }}><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg></span>
          <img className="brand-logo" style={{ height: '60px', margin: '0 auto' }} src="/atz-logo-white.png" alt="ATZ Solution" />
          <span className="eyebrow">Ready when you are</span>
          <h2>Let's win your next federal contract together.</h2>
          <p>Book a free consultation and a specialist will map the exact registrations, certifications, and proposal support your business needs to compete.</p>
          <div className="hero-actions">
            <a className="btn btn-light" href="/contact-us/">Book a Free Consultation <span className="arw">→</span></a>
            <Link className="btn btn-outline-light" to="/portfolio/">View More Projects</Link>
          </div>
          <div className="call">Prefer to talk now? Call <b>(704) 459-8642</b> · Mon–Fri 9:00–6:00 ET</div>
        </div>
      </section>

    </main>
  );
}
